// extracted by mini-css-extract-plugin
module.exports = {"root":"Claim_root__v30s9"};